module.exports = __webpack_public_path__ + "static/media/enlarge.c750f0eb.svg";